import type { App } from 'vue';
import {
  plugin as unleashPlugin,
  UnleashClient,
} from '@unleash/proxy-client-vue';
import { setUnleashClient } from '@/helpers/unleash';

export function installUnleash(app: App): UnleashClient {
  const unleashClient = new UnleashClient({
    url: 'https://unleash-edge.cutr.com/api/frontend',
    clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY,
    refreshInterval: 15,
    appName: import.meta.env.VITE_CUTR_ENV,
    environment: import.meta.env.VITE_CUTR_ENV,
  });

  setUnleashClient(unleashClient);
  app.use(unleashPlugin, { unleashClient });

  return unleashClient;
}
